import vue from '../main'

export const MessageUtil = {
  tipsConfirm: (message, type, ok, cancel) => {
    vue.$confirm(message, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: type
    }).then(() => {
      ok && ok()
    }).catch(() => {
      cancel && cancel()
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/MessageUtil.js